/**
 * SW sync debounce intervals. Entities built with `createSyncedEntity` debounce
 * once ({@link DEFAULT_API_SYNC_DEBOUNCE_MS}); the services not built with it
 * (issue form, selected project) still batch their internal pull with
 * {@link ENTITY_SERVICE_SYNC_DEBOUNCE_MS}.
 */

/** Debounce of syncs from the API: the first runs at once, the next at most once per interval. */
export const DEFAULT_API_SYNC_DEBOUNCE_MS = 2_000;

/** Trailing debounce of the internal pull of the services not built with `createSyncedEntity`. */
export const ENTITY_SERVICE_SYNC_DEBOUNCE_MS = 250;
